import styled from '@emotion/styled';
import { SPACING, ZINDEX } from '@zola/zola-ui/src/styles/emotion';
import COLORS, { COLORS_BACKGROUND } from '@zola/zola-ui/src/styles/emotion/colors';

export const Container = styled.div`
  position: relative;
  top: 0;
  z-index: ${ZINDEX.middle};
  padding: ${SPACING.XS} ${SPACING.SM};
  background-color: ${COLORS_BACKGROUND.DARK_GRAY};
  color: ${COLORS.WHITE};
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
